import { render, staticRenderFns } from "./DashboardProfile.vue?vue&type=template&id=5af2ae7c&"
import script from "./DashboardProfile.vue?vue&type=script&lang=js&"
export * from "./DashboardProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports